import { Either, isLeft, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import generateAudioLinkApiImpl from "../../qa/api/generate_audio_link.api.impl";
import uploadAudioFileApiImpl from "../../qa/api/upload_audio_file.api.impl";
import KeyWordLocalization from "../../../../presentation/utils/KeyWordLocalization";

const uploadAudioForTranscriptionApiImpl = async (_: { audio: File, iaAgentId: string, humanAgentId: string, onCallBack?: (progress: number, message: string) => void }): Promise<Either<ErrorEntity, string>> => {
    try {
        const dataUrl = await generateAudioLinkApiImpl({
            audios: [_.audio.name],
            agentId: _.iaAgentId,
            humanAgentId: _.humanAgentId
        });
        if (isLeft(dataUrl)) return dataUrl;
        const { url, jobID } = dataUrl.right;
        _.onCallBack?.(0, KeyWordLocalization.CheckAudioWithQuestionsUseCaseUploadingAudio);
        const responseUpload = await uploadAudioFileApiImpl(_.audio, url);
        if (isLeft(responseUpload)) return responseUpload;
        _.onCallBack?.(0, KeyWordLocalization.CheckAudioWithQuestionsUseCaseUploadedAudio);
        return right(jobID);
    } catch (error) {
        return left(ErrorEntity.fromError(error));
    }
}

export default uploadAudioForTranscriptionApiImpl;